"use strict";

module.exports = {
  ACTION: 'ACTION',
  EDIT: 'EDIT',
  COMMENT: 'COMMENT',
  READ: 'READ'
};